// import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import ZipForm from '~components/ZipCodeForm/ZipCodeForm';

interface IProps {
    inputLabel?: string;
    buttonTitle?: string;
    zipFormQaValue?: string;
    moreInfo?: boolean;
}

const ZipOnly = ({
    inputLabel = 'Main office ZIP code',
    buttonTitle = 'See plans',
    zipFormQaValue = '',
    moreInfo = false,
}: PropsWithChildren<IProps>) => {
    return (
        <div className="mb-5 sm:m-0 w-full">
            <ZipForm
                inputLabel={inputLabel}
                buttonTitle={buttonTitle}
                buttonTitleMobile={buttonTitle}
                buttonWaLink="Hero Zip Only: see plans"
                qaValue={`HeroStepper${zipFormQaValue && `-${zipFormQaValue}`}`}
                moreInfo={moreInfo}
                opts={{
                    btnStyle: 'primary',
                    useWideLayout: true,
                }}
                redirect={{
                    toUrl: process.env.GATSBY_EHMP_URL,
                    delay: 500,
                }}
            />
        </div>
    );
};

export default ZipOnly;
